
<hr>
<h2>Add Customer Address: </h2><button class="cancel btn btn-warning" (click)="goBack()">Cancel</button>
<hr>
<div>
    <form [formGroup]="myForm" (ngSubmit)="addCustomerAddress()" novalidate>
        <div class="form-group" >
            <label for="customercode">Customer Code</label>
            <div><label>{{this.myForm.value.customercode}}</label></div>
            <input type="hidden" class="form-control" formControlName="customercode"  id="customercode"  />
        </div>

        <div class="form-group">
            <label for="addressserial">Ship To Address Serial Code (optional, auto-generated)</label>
            @if (myForm.get('addressserial')?.invalid) {
                <div class="help-block">Address Serial Code has too many characters.</div>
            }       
            <input type="text" class="form-control" formControlName="addressserial" id="addressserial" />    
        </div>

        <div class="form-group">
            <label for="subsectorcode">Sub Sector Code</label>
            @if (myForm.get('subsectorcode')?.invalid) {
                @if (subsectorcode?.errors?.['maxlength']) {
                    <div class="help-block">
                        Subsector Code has too many characters.
                    </div>
                }
                @if (subsectorcode?.errors?.['required']) {
                    <div class="help-block">
                        Subsector Code is required.
                    </div>
                }
            }                            
            <select formControlName="subsectorcode" id="subsectorcode"  required>
                @for (subsector of subsectors; track subsector.code) {
                    <option value = {{subsector.code}}>{{subsector.description}}</option>
                }
            </select>
        </div>

        <div class="form-group" >
            <label for="salesareacode">Sales Area Code (optional - autogenerated)</label>
            @if (myForm.get('salesareacode')?.invalid) {
                <div class="help-block">Sales Area Code has too many characters.</div>
            }       
            <input type="text" class="form-control" formControlName="salesareacode"  id="salesareacode" />        
        </div>

        <div class="form-group" >
            <label for="accountcode">Customer Account Code OEM (optional)</label>
            @if (myForm.get('accountcode')?.invalid) {
                <div class="help-block">Account Code has too many characters.</div>
            }       
            <input type="text" class="form-control" formControlName="accountcode"  id="accountcode" />    
        </div>

        <div class="form-group" >
            <label for="ordercode">Customer Order Code OEM (optional)</label>
            @if (myForm.get('ordercode')?.invalid) {
                <div class="help-block">Order Code has too many characters.</div>
            }       
            <input type="text" class="form-control" formControlName="ordercode"   id="ordercode"/>    
        </div>

        <div class="form-group" >
            <label for="addressline1">Address Line 1</label>
            @if (myForm.get('addressline1')?.invalid) {
                @if (addressline1?.errors?.['required']) {
                    <div class="help-block">
                        Address Line 1 is required.
                    </div>
                }
                @if (addressline1?.errors?.['maxlength']) {
                    <div class="help-block">
                        Address Line 1 has too many characters.
                    </div>
                }
                @if (addressline1?.errors?.['minlength']) {
                    <div class="help-block">
                        Address Line 1 must be at lease 3 characters.
                    </div>
                }
            }            
            <input type="text" class="form-control" formControlName="addressline1" id="addressline1" />
        </div>

        <div class="form-group" >
            <label for="addressline2">Address Line 2 (optional)</label>
            @if (myForm.get('addressline2')?.invalid) {
                <div class="help-block">Address Line 2 has too many characters.</div>
            }
            <input type="text" class="form-control" formControlName="addressline2"  id="addressline2" />    
        </div>

        <div class="form-group" >
            <label for="addresszip">Zip</label>
            @if (myForm.get('addresszip')?.invalid) {
                @if (addresszip?.errors?.['maxlength']) {
                    <div class="help-block">
                        Zip has too many characters.
                    </div>
                }
                @if (addresszip?.errors?.['required']) {
                    <div class="help-block">
                        Zip is required.
                    </div>
                }
            }            
            <input type="text" class="form-control" formControlName="addresszip" id="uploaded" />
        </div>

        <div class="form-group">
            <button  type="submit" [disabled]="!myForm.valid"  class="btn btn-primary">Add</button>
        </div>

    </form>
</div>